var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { decode } from 'html-entities';
import { forwardRef, useEffect, useRef } from 'react';
import { Linking, Text } from 'react-native';
import { checkIsPlatform, getTestId, isValidObject } from '../../../../utils';
import { getTypographyStyles } from '../../TypographyStyles';
import { GradientText } from '../gradient-text';
export var SingleText = forwardRef((typographyProps, ref) => {
  var typographyStyles = getTypographyStyles(typographyProps);
  var id = typographyProps.id,
    type = typographyProps.type,
    _text = typographyProps.text,
    isHyperLink = typographyProps.isHyperLink,
    hyperLinkProps = typographyProps.hyperLinkProps,
    noTextTransform = typographyProps.noTextTransform,
    gradient = typographyProps.gradient,
    isStriked = typographyProps.isStriked,
    textAlignment = typographyProps.textAlignment,
    _onPress = typographyProps.onPress,
    style = typographyProps.style,
    _typographyProps$test = typographyProps.testID,
    testID = _typographyProps$test === void 0 ? 'SingleText' : _typographyProps$test,
    title = typographyProps.title,
    tagName = typographyProps.tagName,
    multiText = typographyProps.multiText,
    restProps = __rest(typographyProps, ["id", "type", "text", "isHyperLink", "hyperLinkProps", "noTextTransform", "gradient", "isStriked", "textAlignment", "onPress", "style", "testID", "title", "tagName", "multiText"]);
  var text = decode(_text);
  var inputRef = useRef();
  var _ref = ref || inputRef;
  var isHyperLinkText = isHyperLink || !!(hyperLinkProps === null || hyperLinkProps === void 0 ? void 0 : hyperLinkProps.href);
  var textStyles = [typographyStyles.typography, noTextTransform && typographyStyles.noTextTransform, isHyperLinkText && typographyStyles.hyperLink, isStriked && typographyStyles.strikedText, textAlignment && typographyStyles.singleTextAlignText, style];
  var isSingleLineText = !!(type === null || type === void 0 ? void 0 : type.includes('single-line')) || !!(type === null || type === void 0 ? void 0 : type.includes('button-text'));
  var textProps = Object.assign(Object.assign(Object.assign(Object.assign({
    accessibilityLabel: text,
    minimumFontScale: 1,
    maxFontSizeMultiplier: 1.5,
    allowFontScaling: true
  }, isHyperLinkText && {
    href: hyperLinkProps === null || hyperLinkProps === void 0 ? void 0 : hyperLinkProps.href,
    role: 'link',
    hrefAttrs: {
      target: (hyperLinkProps === null || hyperLinkProps === void 0 ? void 0 : hyperLinkProps.target) || '_self'
    },
    onPress: event => {
      if (hyperLinkProps === null || hyperLinkProps === void 0 ? void 0 : hyperLinkProps.preventReload) {
        event.preventDefault();
      }
      if (!checkIsPlatform('web') && (hyperLinkProps === null || hyperLinkProps === void 0 ? void 0 : hyperLinkProps.href)) {
        Linking.canOpenURL(hyperLinkProps.href).then(supported => {
          if (supported) Linking.openURL(hyperLinkProps.href);
        });
      }
      _onPress === null || _onPress === void 0 ? void 0 : _onPress({
        event,
        props: typographyProps,
        id
      });
    }
  }), isSingleLineText && {
    numberOfLines: 1
  }), getTestId(testID)), restProps);
  useEffect(() => {
    var _a;
    if (checkIsPlatform('web')) {
      if (_ref === null || _ref === void 0 ? void 0 : _ref.current) {
        if (title) _ref.current.title = title;
        (_a = _ref === null || _ref === void 0 ? void 0 : _ref.current) === null || _a === void 0 ? void 0 : _a.setAttribute('data-type', type);
      }
    }
  }, [title]);
  if (tagName && checkIsPlatform('web')) {
    var CustomTag = tagName;
    var flattenedStyles = Object.assign({}, ...textStyles.filter(Boolean), Object.assign(Object.assign({}, isValidObject(multiText) && {
      display: 'inline'
    }), {
      lineHeight: typographyStyles.typography.lineHeight + "px",
      marginBlock: 0,
      marginInline: 0
    }));
    return _jsx(CustomTag, Object.assign({
      ref: _ref
    }, getTestId(testID, tagName), textProps, {
      style: flattenedStyles
    }, {
      children: text
    }));
  }
  if (isHyperLinkText && !!text && !gradient) {
    return _jsx(Text, Object.assign({
      ref: _ref
    }, textProps, checkIsPlatform('web') && {
      tabIndex: 1
    }, {
      style: textStyles
    }, getTestId(testID), {
      children: text
    }));
  }
  return _jsxs(_Fragment, {
    children: [!isHyperLinkText && !!text && !gradient && _jsx(Text, Object.assign({
      ref: _ref
    }, getTestId(testID), textProps, {
      style: textStyles
    }, {
      children: text
    })), !!gradient && _jsx(GradientText, Object.assign({
      ref: ref,
      type: gradient,
      typographyProps: typographyProps
    }, getTestId(testID)))]
  });
});